import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialLaboratoryState: Dtos.Laboratory & IRegistrationFormState = {
    id: null,
    name: null,
    address: null,
    suburb: null,
    postcode: null,
    phone: null,
    countryId: null,
    country: null,
    stateId: null,
    state: null,
    facsimileNumber: null,
    additionalInformation: null,
    accreditationCertificate: null,
    accreditationNumber: null,
    ranges: null,
    yearRange: null,
    multiSiteAdvisory: null,
    supportingInformation: null,
    comments: null,
    active: null,
    dateInactive: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    laboratoryDepartments: null,
    abn: null,
    laboratoryPersonnels: [],
    institutionLaboratories: [],
    laboratoryFinance: null
}

export interface ILaboratoryReduxFormState {
    id: IFieldState<number>,
    name: IFieldState<string>,
    address: IFieldState<string>,
    suburb: IFieldState<string>,
    postcode: IFieldState<string>,
    phone: IFieldState<string>,
    countryId: IFieldState<number>,
    country: IFieldState<Dtos.Country>,
    stateId: IFieldState<number>,
    state: IFieldState<Dtos.State>,
    facsimileNumber: IFieldState<string>,
    additionalInformation: IFieldState<string>,
    accreditationCertificate: IFieldState<string>,
    accreditationNumber: IFieldState<string>,
    ranges: IFieldState<string>,
    yearRange: IFieldState<string>,
    multiSiteAdvisory: IFieldState<string>,
    supportingInformation: IFieldState<string>,
    comments: IFieldState<number>,
    active: IFieldState<boolean>,
    dateInactive: IFieldState<string>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    saveAndReturn: IFieldState<boolean>,
    abn: IFieldState<number>,
    laboratoryPersonnels: IFieldState<Dtos.LaboratoryPersonnel[]>,
    institutionLaboratories: IFieldState<Dtos.InstitutionLaboratory[]>,
    laboratoryFinance: IFieldState<Dtos.LaboratoryFinance>
}
